<template>
  <div class="wrap" ref="wrap">
    <a-space direction="vertical" style="width:100%" size="middle">
      <a-row type="flex">
        <a-space>
          <a-space>
            <span>姓名: </span>
            <a-input placeholder="输入用户名模糊查询" style="width: 200px" v-model="fuzzyMap.username" @keyup.enter.native="search" />
          </a-space>
          <a-space>
            <span>手机号: </span>
            <a-input placeholder="输入手机号模糊查询" style="width: 200px" v-model="fuzzyMap.phoneNum" @keyup.enter.native="search" />
          </a-space>
          <a-space>
            <a-button type="primary" @click="search">搜索</a-button>
            <a-button type="primary" @click="reset">重置</a-button>
            <a-button type="primary" @click="batchExportExcel">导出</a-button>
            <a-button type="primary" @click="openDeleteModal">删除</a-button>
          </a-space>
        </a-space>
      </a-row>

      <a-table :columns="columns" :data-source="data" size="small" :scroll="tableScroll" :row-selection="{
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange
      }" :rowKey="(record) => record.userId" :pagination="false" :loading="loading">
       
        <template slot="isVip" slot-scope="render">
          <a-tag :color="render == 1 ? 'green' : 'red'">
            {{ render==1 ? "会员" : "非会员" }}
          </a-tag>
        </template>

        <div slot="action" slot-scope="render">
          <a @click="showAuthMode(render)">授权</a>

        </div>
        <a-row slot="footer" type="flex" justify="end">
          <a-pagination v-model="page" :page-size-options="pageSizeOptions" :total="total" :show-total="(total) => `共 ${total} 个用户`" show-size-changer :page-size="pageSize" @showSizeChange="onShowSizeChange" @change="pageChange" size="small">
            <template slot="buildOptionText" slot-scope="props">
              <span>{{ props.value }}条/页</span>
            </template>
          </a-pagination>
        </a-row>
      </a-table>
    </a-space>

    <a-modal v-model="authProjectInfo" title="科目授权">
      <a-form-model ref="authForm" :model="userForm" :rules="rules" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
        <a-form-model-item label="姓名" required prop="username">
          <a-input v-model="userForm.username"/>
        </a-form-model-item>
        <a-form-model-item label="科目" required prop="projectName">
          <a-select v-model="userForm.projectName" placeholder="请选择科目" @change="handleChange">
            <a-select-option
              :value="item.id || item.name"
              v-for="item in options"
              :key="item.id"
            >{{item.name}}</a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
      <div slot="footer">
        <a-button type="primary" :loading="sumbitLoading" @click="updateToVip()">确认</a-button>
      </div>
    </a-modal>

    <a-modal v-model="showDeleteModal" @ok="deleteInfo()">
      <p>是否确认删除该会员信息？</p>
    </a-modal>
  </div>
</template>

<script>
import { user, project } from '@/request/api.js';
import { mapState } from "vuex"

const columns = [
  {
    title: '序号',
    dataIndex: "index",
    align: 'center',
    width: '50px',
    customRender:(text, render, index) => `${index + 1}`
  },
  {
    title: '用户名',
    dataIndex: 'username',
    align: 'center',
    width: '150px',
  },
  {
    title: '用户类型',
    dataIndex: 'isVip',
    align: 'center',
    width: '150px',
    scopedSlots: { customRender: 'isVip' },
  },
  {
    title: '手机号',
    dataIndex: 'phoneNum',
    width: '180px',
    align: 'center',
  },
  {
    title: '科目',
    dataIndex: 'projectName',
    width: '150px',
    align: 'center'
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
    width: '150px',
    align: 'center'
  },
  {
    title: '操作',
    key: 'operation',
    width: '180px',
    align: 'center',
    scopedSlots: { customRender: 'action' },
  },
];

export default {
  data() {
    return {
      data: [],
      selectedRowKeys: [],
      columns,
      loading: false,
      fuzzyMap:{
        'username':'',
        'phoneNum':''
      },
      page: 1,
      pageSize: 10,
      tableScroll: {},
      total: 0,
      pageSizeOptions: ['10', '20', '50'],
      project:{},
      userForm: {
        userId:'',
        username: '',
        paojectName:''
      },
      rules: {
        username: [
          { required: true, message: "请填写用户名", trigger: "change" }
        ],
        projectName: [
          { required: true, message: "请选择科目", trigger: "change" }
        ],
      },
      options:[],
      sumbitLoading: false,
      authProjectInfo: false,
      showDeleteModal: false
    };
  },
  created() {},
  mounted() {
    this.findUser();
    this.loadParentProject();
    this.tableScroll = { y: document.body.clientHeight - 300 };
  },
  methods: {
    findUser() {
      this.loading = true;
      let params = {};
      if (this.page < 1) {
        this.page = 1;
      }
      params.fuzzyMap = this.fuzzyMap;
      params.page = this.page - 1;
      params.size = this.pageSize;

      if (this.userInfo.staffLevel == 2) {
        params.projectId = this.userInfo.projectId;
      }

      user
        .query(params)
        .then((response) => {
          let total = response.total;
          let data = response.data;
          let loading = false;
          Object.assign(this, {
            data,
            total,
            loading,
          });
        })
        .catch((e) => {
          console.error(e);
          this.loading = false;
        });
    },
    search() {
      this.findUser();
    },
    reset() {
      let fuzzyMap = {
        'usernme':'',
        'phoneNum':''
      }
      Object.assign(this, {
        fuzzyMap,
      });
      this.search();
    },

    /**
     * 查询可授权的科目信息
     */
    loadParentProject() {
      project.queryParent()
        .then((options) => {
          if (this.userInfo.staffLevel == 2) {
            options = options.filter((item) => item.id == this.userInfo.projectId);
          }
          Object.assign(this, {
            options
          })
        })
    },
    /**
     * 授权
     * @param {*} render 会员信息
     */
    showAuthMode(render) {
      let userForm = {
        userId: render.userId,
        username: render.username,
        projectId: render.projectId ? render.projectId : this.options[0].id,
        projectName: render.projectName ? render.projectName : this.options[0].name
      };
      let authProjectInfo= true;
      Object.assign(this, {
        userForm,
        authProjectInfo
      });
    },
    updateToVip() {
      this.$refs.authForm.validate((valid) => {
        if (valid) {
          user.authProject(this.userForm)
        .then(() => {
          let authProjectInfo = false;
          Object.assign(this, {
            authProjectInfo
          });
          this.findUser();
        })
        .catch((e) => {
          console.error(e);
          this.loading = false;
        });
        } else {
          this.$message.warn("请填写用户名或科目信息")
        }
      })
    },
    handleChange(projectId) {
      let projectInfo = this.options.filter((item) => item.id == projectId)[0];
      let userForm = this.userForm;
      userForm.projectId = projectInfo.id;
      userForm.projectName = projectInfo.name;
      Object.assign(this, {
        userForm
      });
    },
    onShowSizeChange(page, pageSize) {
      this.page = page;
      this.pageSize = pageSize;
      this.findUser();
    },
    pageChange() {
      this.findUser();
    },
    batchExportExcel() {
      if (this.selectedRowKeys.length > 0) {
        let params = {
          ids: this.selectedRowKeys
        }
        user.exportUserInfo(params, "用户信息.xlsx")
          .then(() => {
            this.selectedRowKeys = []
          })
          .catch(() => {})
      } else {
        this.$message.warn('请选中数据');
      }
    },
    onSelectChange(selectedRowKeys) {
      console.log('selectedRowKeys changed: ', selectedRowKeys)
      this.selectedRowKeys = selectedRowKeys
    },
    /**
     * 打开删除信息提示窗口
     */
     openDeleteModal() {
      if (this.selectedRowKeys.length < 1) {
        this.$message.warn('请选择需要删除的用户信息');
      } else {
        this.showDeleteModal = true
      }
    },
    deleteInfo() {
      user.deleteUserInfo(this.selectedRowKeys)
      .then(() => {
        this.$message.success("删除成功")
        this.showDeleteModal = false
        this.findUser()
      })
    }
  },
  computed: {
    ...mapState(["token", "userInfo"])
  }
};
</script>

<style lang="stylus" scoped>
.wrap {
  display: flex;
}
</style>
